import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { objectEach } from 'highcharts';
import { userDetalleOpLst } from 'src/app/models/userLst';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { PlanService } from 'src/app/services/plan.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-detalle-orden-compra-reporte-admin',
  templateUrl: './detalle-orden-compra-reporte-admin.component.html',
  styleUrls: ['./detalle-orden-compra-reporte-admin.component.scss']
})
export class DetalleOrdenCompraReporteAdminComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  public saldo: number = 0;
  public valOrdenTmp: number = 0;
  public lstPlanes: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    public dialog: MatDialog,
    public planSvc: PlanService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DetalleOrdenCompraReporteAdminComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: userDetalleOpLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'plan',
      'valor',
      'fecha',
     // 'estado',
      'estadoUsuario',
      'comentario',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    this.getDetalleOrdenCompra();
  }

  getDetalleOrdenCompra() {
    this.isLoadingResults = true;
    this.ordenCompraSvc
      .getDetalleOrdenCompraAdmin(this.dataInput)
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<any>(result);

        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
